import "bootstrap/dist/css/bootstrap.min.css";
import { useCallback, useEffect } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./App.css";
import AuthVerify from "./common/AuthVerify";
import EventBus from "./common/EventBus";
import Hero from "./pages/hero/Hero";
import PageNotFound from "./pages/hero/404Page";
import AdminProfile from "./pages/profile/AdminProfile";
import InitiatorProfile from "./pages/profile/InitiatorProfile";
import ReviewerProfile from "./pages/profile/ReviewerProfile";
import ApproverProfile from "./pages/profile/ApproverProfile";
import UserProfile from "./pages/profile/UserProfile";
import Approval from "./pages/approval/Approval";
import Initiator from "./pages/initiator/Initiator";
import Reviewer from "./pages/reviewer/Reviewer";
import Expenditure from "./pages/expenditure/Expenditure";
import ReviewerHome from "./pages/home/ReviewerHome";
import ApprovalHome from "./pages/home/ApprovalHome";
import ProjectBoard from "./pages/home/ProjectBoard";
import Chatbox from "./pages/chatbox/Chatbox";
import AuthService from "./services/auth.service";
import { createBrowserHistory } from "history";
import PrivateRoute from "./components/PrivateRoute";
import User from "./pages/user/User";
import UserList from "./pages/userList/UserList";
import NewUser from "./pages/newUser/NewUser";
import Setting from "./pages/setting/Setting";
import StaffDatabase from "./pages/home/StaffDatabase";

function App() {
	const history = createBrowserHistory();
	const logout = useCallback(() => {
		AuthService.logOut(history);
	}, [history]);

	useEffect(() => {
		EventBus.on("logout", () => {
			logout();
		});

		return () => {
			EventBus.remove("logout");
		};
	}, [logout, ]);

	return (
		<Router history={history}>
			<div id="app">
				<Switch>
					<Route exact path="/" component={Hero} />
					<PrivateRoute exact path="/admin/profile">
						<AdminProfile />
					</PrivateRoute>
					<PrivateRoute exact path="/approver/profile">
						<ApproverProfile />
					</PrivateRoute>
					<PrivateRoute exact path="/reviewer/profile">
						<ReviewerProfile />
					</PrivateRoute>
					<PrivateRoute exact path="/initiator/profile">
						<InitiatorProfile />
					</PrivateRoute>
					<PrivateRoute exact path="/user/profile">
						<UserProfile />
					</PrivateRoute>
					<PrivateRoute exact path="/board/projects">
						<ProjectBoard />
					</PrivateRoute>
					<PrivateRoute exact path="/initiator/desk">
						<Initiator />
					</PrivateRoute>
					<PrivateRoute exact path="/reviewer/desk">
						<ReviewerHome />
					</PrivateRoute>
					<PrivateRoute exact path="/reviewer/desk/:projectID">
						<Reviewer />
					</PrivateRoute>
					<PrivateRoute exact path="/approval/desk">
						<ApprovalHome />
					</PrivateRoute>
					<PrivateRoute exact path="/approval/desk/:projectID">
						<Approval />
					</PrivateRoute>
					<PrivateRoute exact path="/expenditure">
						<Expenditure />
					</PrivateRoute>
					<PrivateRoute exact path="/admin/users">
						<UserList />
					</PrivateRoute>
					<PrivateRoute exact path="/admin/user/:userId">
						<User />
					</PrivateRoute>
					<PrivateRoute path="/admin/newUser">
						<NewUser />
					</PrivateRoute>
					<PrivateRoute exact path="/settings" component={Setting} />
					<PrivateRoute exact path="/staff-database" component={StaffDatabase} />
					<PrivateRoute exact path="/messenger">
						<Chatbox />
					</PrivateRoute>
					<PrivateRoute exact path="/messenger/:receiverId">
						<Chatbox />
					</PrivateRoute>
					<Route component={PageNotFound} />
				</Switch>
				<AuthVerify logout={logout} />
				<Toaster
					position="top-right"
					toastOptions={{
						className: "",
						duration: 5000,
						style: {
							color: "#fff",
						},
						success: {
							style: {
								background: "green",
							},
						},
						error: {
							style: {
								background: "red",
							},
						},
					}}
				/>
			</div>
		</Router>
	);
}

export default App;
